import request from '@/utils/http';
// 查询产品信息
export const searchPro = (salesCode) => {
    return request({
        url: `/api-sn/scene/product/home/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询产品成品下线
export const searchProOffline = (salesCode) => {
    return request({
        url: `/api-sn/scene/offline/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询产品品质检验
export const searchProQuality = (salesCode) => {
    return request({
        url: `/api-sn/scene/quality/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询产品代理商
export const searchProAgent = (salesCode) => {
    return request({
        url: `/api-sn/scene/agent/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询产品客户安装，维修信息
export const searchProClientInstall = (salesCode) => {
    return request({
        url: `/api-sn/scene/customer/install/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询产品客户使用连接
export const searchProClientConnect = (salesCode) => {
    return request({
        url: `/api-sn/scene/customer/connect/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询产品运输
export const searchProTransport = (salesCode) => {
    return request({
        url: `/api-sn/scene/transport/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询工厂制造-原材料
export const searchMaterial = (salesCode) => {
    return request({
        url: `/api-sn/scene/factory/manufact/material/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询工厂制造-部件
export const searchParts = (salesCode) => {
    return request({
        url: `/api-sn/scene/factory/manufact/parts/search?barcode=${salesCode}`,
        method: 'get'
    });
};
// 查询判断节点状态
export const searchNode = (salesCode) => {
    return request({
        url: `/api-sn/scene/node/status/search?barcode=${salesCode}`,
        method: 'get'
    });
};

// 查询条码刘翔列表详情(收件人地址,人名,手机号)
export const fetchEyeInfo = (params) => {
    return request({
        url: `/api-sn/lbcs/bcBarcode/getReceiverDetails`,
        method: 'post',
        data: params
    });
};

// 点击小眼睛,查询列表详情信息记录日志
export const fetchEyeInfoLog = (params) => {
    return request({
        url: `/api-sn/sendLogSecurity`,
        method: 'post',
        data: params
    });
};
